/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationBedsAliases {
  BUTTON_CLEAN = 'button-clean',
  BUTTON_CONFIRM = 'button-confirm',
  FETCH_BED = 'fetch-bed',
  FETCH_BEDS = 'fetch-beds',
  FETCH_LIST_BEDS = 'fetch-list-beds',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FIELD_0 = 'field-0',
  FIELD_AMOUNT = 'field-amount',
  FIELD_AMOUNT_LIST = 'field-amount-list',
  FIELD_BED_LIST = 'field-bed-list',
  FIELD_BEDS = 'field-beds',
  FIELD_CARD = 'field-card',
  FIELD_NR_SEQUENCE = 'field-nrSequence',
  FIELD_NR_SEQUENCE_LIST = 'field-nrSequence-list',
  FIELD_QUANTITY_SUS = 'field-quantity-sus',
  FIELD_QUANTITY_SUS_LIST = 'field-quantity-sus-list',
  FORM_0 = 'form-0',
  FORM_BEDS = 'form-beds',
  FORM_PANEL = 'form-panel',
  INPUT_NR_SEQUENCE = 'input-nrSequence',
  INPUT_NR_SEQUENCE_LIST = 'input-nrSequence-list',
  INPUT_QUANTITY = 'input-quantity',
  INPUT_QUANTITY_SUS = 'input-quantity-sus',
  LAYOUT_0 = 'layout-0',
  LAYOUT_GENERAL_INFORMATION = 'layout-general-information',
  LIST_PANEL = 'list-panel',
  MAPPER_0 = 'mapper-0',
  MAPPER_3 = 'mapper-3',
  MY_DATA_CARD = 'my-data-card',
  MY_DATA_DECK = 'my-data-deck',
  PANEL_ACCREDITATION_BED = 'panel-accreditation-bed',
  PANEL_CONFIRM = 'panel-confirm',
  PANEL_PENDENCIES = 'panel-pendencies',
  TEXT_0 = 'text-0',
  TEXT_3 = 'text-3',
  TEXT_3_LIST = 'text-3-list',
  TEXT_4_LIST = 'text-4-list',
  TEXT_QUANTITY_SUS_LIST = 'text-quantity-sus-list',
  TOAST_NOTIFICATION = 'toast-notification',
  UNBOXED_AUTOCOMPLETE_BEDS = 'unboxed-autocomplete-beds',
}
export { ProviderAccreditationBedsAliases };
